import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const ShippingPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen pb-24 pt-48">
      <div className="max-w-4xl mx-auto px-4 md:px-8 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Shipping Policy
          </h1>
          <p className="text-sm mb-12 opacity-70">Effective Date: April 2026</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <p>
              We carefully pack and ship all Ricky's Bees products to ensure they arrive safely. Every jar is carefully packed with the same care we give our bees.
            </p>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>1. Processing Time</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Orders are processed within 1–3 business days</li>
                <li>Orders are not processed on weekends or public holidays</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>2. Shipping Rates</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Flat rate shipping: <strong>$11.95</strong> Australia-wide</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>3. Delivery Timeframes</h2>
              <p className="mb-4">Estimated delivery times:</p>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>Victoria: 2–5 business days</li>
                <li>Interstate: 3–8 business days</li>
              </ul>
              <p className="italic text-sm">(Delivery times may vary depending on courier services.)</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>4. Shipping Providers</h2>
              <p className="mb-4">We use trusted carriers such as:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Australia Post</li>
                <li>Courier services (e.g., Aramex or similar)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>5. Order Tracking</h2>
              <p>Tracking details will be provided once your order has been dispatched.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>6. Delivery Issues</h2>
              <p className="mb-4">Ricky's Bees is not responsible for:</p>
              <ul className="list-disc pl-6 space-y-2 mb-4">
                <li>Delays caused by couriers</li>
                <li>Incorrect shipping addresses provided at checkout</li>
              </ul>
              <p>Please ensure your details are correct before placing your order.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>7. Lost or Damaged Parcels</h2>
              <p className="mb-4">If your order is lost or arrives damaged:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Contact us within 7 days</li>
                <li>We will work with the courier to resolve the issue</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>8. Shipping Honey Safely</h2>
              <p className="mb-4">As honey is a natural product:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Crystallisation may occur (this is normal and does not affect quality)</li>
                <li>Exposure to temperature changes during transit may affect texture</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>9. State Restrictions</h2>
              <p className="mb-4">Due to biosecurity regulations, certain states have restrictions on honey imports:</p>
              <ul className="list-disc pl-6 space-y-3">
                <li>
                  <strong>Western Australia (WA):</strong> Has a near-total ban on private, non-commercial honey imports to prevent the introduction of pathogens. Only pasteurized or commercially certified honey is likely to be accepted.
                </li>
                <li>
                  <strong>South Australia (SA):</strong> Restricts the movement of honey to prevent biosecurity risks.
                </li>
                <li>
                  <strong>Tasmania:</strong> Requires honey to be commercially produced, sealed and labeled.
                </li>
              </ul>
              <p className="mt-4 text-sm italic">Please contact us before ordering if you are located in these states to confirm delivery eligibility.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>10. Contact</h2>
              <p>Email: <a href="mailto:sales@rickysbees.com.au" className="text-primary hover:underline">sales@rickysbees.com.au</a></p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
